import React from 'react'
import Styles from "../../../scss/discounts.module.scss";
import { useCurrencyState } from "../../../yoello-lib/modules/hooks/useCurrencyState";
export function MinOrderAddon() {
  const currency = useCurrencyState();
  return (
    <div className={Styles.minOrderAddonContainer}>
      <span>
        {currency.symbol}
      </span>
      <span className={Styles.divider}/>
    </div>
  )
}
